import { ACTIVE, INACTIVE } from 'AccountsApp/ts/constants/integrations.constants';
import { RedtailIntegrationService } from 'IntegrationsApp/ts/services/redtail-integration-service';
import { ConfirmModalComponent } from 'Angular/features/components/modals/confirm-modal/confirm-modal.component';
import { RedtailCredentialsModalComponent } from 'IntegrationsApp/ts/features/redtail-credentials-modal/redtail-credentials-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/redtail-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "Angular/features/directives/image/image.directive";
import * as i4 from "../../../../../../../../../../integrations/static/integrations/ts/features/redtail-credentials-modal/redtail-credentials-modal.component";
import * as i5 from "../integration-status-indicator/integration-status-indicator.component";
const _c0 = ["ycn-redtail-integration-list-item", ""];
export class RedtailIntegrationListItemComponent {
    constructor(redtailIntegrationService) {
        this.redtailIntegrationService = redtailIntegrationService;
        this.status = '';
    }
    ngOnInit() {
        this.updateStatus(true);
    }
    updateStatus(confirmed) {
        if (confirmed) {
            this.redtailIntegrationService.getRedtailIntegrationStatus().subscribe({
                next: (data) => {
                    this.status = data.isActive ? ACTIVE : INACTIVE;
                },
                error: () => { },
            });
        }
        else {
            this.status = INACTIVE;
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.redtailIntegrationService.deactivateRedtailIntegration().subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus(false);
                }
            });
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.redtailDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.redtailActivateModalComponent.openModal();
        }
    }
}
RedtailIntegrationListItemComponent.ɵfac = function RedtailIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RedtailIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.RedtailIntegrationService)); };
RedtailIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RedtailIntegrationListItemComponent, selectors: [["tr", "ycn-redtail-integration-list-item", ""]], viewQuery: function RedtailIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
        i0.ɵɵviewQuery(RedtailCredentialsModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.redtailDeactivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.redtailActivateModalComponent = _t.first);
    } }, standalone: false, attrs: _c0, decls: 15, vars: 6, consts: [[1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "success", "cancelled"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function RedtailIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td")(1, "div", 0);
        i0.ɵɵelement(2, "img", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtext(4, "Redtail");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings, SSO");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 4)(10, "label", 5)(11, "input", 6);
        i0.ɵɵlistener("change", function RedtailIntegrationListItemComponent_Template_input_change_11_listener() { return ctx.activateToggle(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-redtail-credentials-modal", 8);
        i0.ɵɵlistener("success", function RedtailIntegrationListItemComponent_Template_ycn_redtail_credentials_modal_success_13_listener() { return ctx.updateStatus(true); })("cancelled", function RedtailIntegrationListItemComponent_Template_ycn_redtail_credentials_modal_cancelled_13_listener() { return ctx.updateStatus(false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "ycn-confirm-modal", 9);
        i0.ɵɵlistener("confirmHandler", function RedtailIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_14_listener($event) { return ctx.deactivateHandler($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/redtail-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Redtail Integration")("confirmText", "Are you sure you would like to deactivate your integration with Orion? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.RedtailCredentialsModalComponent, i5.IntegrationStatusIndicatorComponent], encapsulation: 2 });
